import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface ConfirmDeleteDialogData {
  title: string;
  message: string;
}

@Component({
  selector: 'app-confirm-delete-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    <mat-dialog-content>
      <p class="msg">{{ data.message }}</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button type="button" (click)="ref.close(false)">
        Annuller
      </button>
      <button
        mat-raised-button
        color="warn"
        type="button"
        (click)="ref.close(true)"
      >
        Slet
      </button>
    </mat-dialog-actions>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [
    `
      .msg {
        margin: 0;
        line-height: 1.5;
      }
      h2 {
        font-size: 1.1rem;
        font-weight: 600;
      }
    `,
  ],
})
export class ConfirmDeleteDialogComponent {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDeleteDialogData,
    public ref: MatDialogRef<ConfirmDeleteDialogComponent, boolean>
  ) {}
}
